import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceConfigService } from '@app/services/service-config.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'letters',
    templateUrl: './letters.component.html',
    styleUrls: ['./letters.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class LettersComponent implements OnInit {

  enableLtssLettersSwitch:boolean;
  defaultLanguage: string;
  translatedLang: string;
  globalLang;
  currentLang;

  constructor(private router: Router,private serverConfig: ServiceConfigService, public translateService: TranslateService) { }
  ngOnInit(): void {
    this.globalLang = sessionStorage.getItem('globalTranslatedLan');
    this.currentLang = sessionStorage.getItem('currentLang');
    sessionStorage.removeItem('submitSuccess');
    this.enableLtssLettersSwitch=this.serverConfig.getServerConfig().enableLtssLettersSwitch;
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.currentLang = this.translatedLang;
    });
  }

  goTo () {
    this.router.navigate(['/user-profile/letters', 'my-letters'])
  }

}
